/**
 * @file 追跡者詳細ポップアップ
 *
 */
'use strict';

/**
 * @classname TrackingPopup
 * @classdesc 追跡者詳細ポップアップ
 */
export default class TrackingPopup {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.block-tracking-detail')
	 */
	constructor($e) {
		console.log('TrackingPopup.constructor');
		this._$e = $e;
		this._popOverText = $e.text();
		$e.on('click', (e) => {this.onClick();});
	};


	/**
	 * @memberof TrackingPopup
	 */
	onClick(){
		console.log('TrackingPopup.onClick');
		const popOver = `<div class="block block-tracking-detail-popup-bg">
	<div class="block block-tracking-detail-popup">
		<a class="anchor anchor-popup-close" href="javascript:void(0);">閉じる</a>
		${this._popOverText}
	</div>
</div>`
		$('body').append(popOver);
		$('.block-tracking-detail-popup-bg').on('click', () => {
			$('.block-tracking-detail-popup-bg').remove();
		})
		$('.block-tracking-detail-popup').on('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
		});
		$('.anchor-popup-close').on('click', () => {
			$('.block-tracking-detail-popup-bg').remove();
		})
	}
}
